import * as angular from 'angular';
import { Avalara } from './avalara.service';

export const avalaraModelModule = angular.module('avalaraModel', [

])
	.service('Avalara', Avalara)
	.name;
